<template>
<div class="share" v-show="showFlag" @click="hidewrap">
  <span class="handfont">点击这里<br/>分享给朋友</span>
  <img src="./img/hand.png" class="hander" />
</div>
</template>

<script>
export default {
  name: 'share',
  props: {
    showFlag: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    hidewrap () {
      this.$emit('hidewrap')
    }
  }
}
</script>

<style scoped>
.share{
  width: 100%;
  height: 100%;
  position: fixed;
  top:0;
  background-color: rgba(0,0,0,0.4);
  z-index: 2;
  left: 0;
  text-align: right;
  vertical-align: middle;
}
.hander{
  width: 1.44rem;
  vertical-align: middle;
  margin-right: -0.4rem;
}
.handfont{
    font-size: 0.26rem;
    color: white;
    display: inline-block;
    vertical-align: middle;
}
</style>
